import { render, staticRenderFns } from "./SearchGroup.vue?vue&type=template&id=3507cfb1&scoped=true"
import script from "./SearchGroup.vue?vue&type=script&lang=ts"
export * from "./SearchGroup.vue?vue&type=script&lang=ts"
import style0 from "./SearchGroup.vue?vue&type=style&index=0&id=3507cfb1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3507cfb1",
  null
  
)

export default component.exports